import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "text" }

import { computed } from 'vue';
import { ReloadOutlined } from '@ant-design/icons-vue';
import { ISUBMIT_SOURCE } from '@/apis/common';
import pc_nowifi from '@/assets/img/n_wifi1.png';
import mobile_nowifi from '@/assets/img/n_wifi.png';


export default /*@__PURE__*/_defineComponent({
  __name: 'ErrorPage',
  props: {
  errorText: {
    type: String,
    required: true,
  },
  platform: {
    type: String,
    required: true,
    default: ISUBMIT_SOURCE.PC,
  },
},
  setup(__props) {

const props = __props;

const getClassNames = computed(() => {
  return props.platform === ISUBMIT_SOURCE.PC ? 'desktop' : 'mobile';
});

const getImgSrc = computed(() => {
  return props.platform === ISUBMIT_SOURCE.PC ? pc_nowifi : mobile_nowifi;
});

const reload = () => {
  location.reload();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(getClassNames.value)
  }, [
    _createElementVNode("img", {
      src: getImgSrc.value,
      alt: "无网络",
      class: "nowifi-icon"
    }, null, 8, _hoisted_1),
    _createElementVNode("div", _hoisted_2, _toDisplayString(__props.errorText), 1),
    _createElementVNode("div", {
      class: "reload",
      onClick: reload
    }, [
      _createVNode(_unref(ReloadOutlined)),
      _cache[0] || (_cache[0] = _createElementVNode("span", { class: "text" }, "重新刷新", -1))
    ])
  ], 2))
}
}

})